<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Dashboard de Chargeback do Marketplace</h3>
          <h6 class="label-red" v-if="filter.IdMerchantRoot == 0">
            * Para consultar, é necessário informar o IdMerchantRoot
          </h6>
        </div>
        <div class="col-6 d-flex" v-if="!loading">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>
      <d-row style="justify-content: center" v-if="filter.IdMerchantRoot > 0">
        <!-- Cards -->
        <d-col
          v-for="(card, index) in Cards"
          :key="index"
          md="6"
          lg="4"
          class="mb-4"
        >
          <cards
            :id="`card-${index}`"
            :link="card.link"
            :label="card.label"
            :value="card.value"
          />
        </d-col>
      </d-row>

      <div class="row equal-cols">
        <d-col class="mb-12 col-lg-12 lg-s">
          <d-row
            v-if="
              this.infoDashboard != null &&
              this.infoDashboard.ChargebackSubaccount.length > 0
            "
          >
            <d-col class="mb-12 col-lg-12 lg-s">
              <d-card class="card-small">
                <!-- Card Header -->
                <d-card-header class="border-bottom">
                  <div class="float-left">
                    <h6 class="m-0" style="font-weight: 600">
                      Top 10 subcontas com chargeback
                    </h6>
                  </div>
                  <div class="float-right">
                    <i class="fas fa-money-check-alt"></i>
                  </div>
                </d-card-header>
                <d-card-body class="p-0">
                  <!-- Services List Group -->
                  <d-list-group flush class="list-group-small">
                    <d-list-group-item
                      v-for="(item, index) in this.infoDashboard
                        .ChargebackSubaccount"
                      :key="index"
                      class="d-flex px-3"
                    >
                      <h6
                        :title="item.Merchant.Name"
                        v-b-tooltip.hover.bottom
                        class="text-semibold text-nowrap text-fiord-blue text-ellipsis"
                      >
                        {{ item.Merchant.Name }}
                      </h6>
                      <span
                        class="ml-auto text-nowrap text-right text-semibold padding-left-item"
                      >
                        <strong>{{ item.CountChargeback }} </strong>
                        {{
                          item.CountChargeback == 1
                            ? "chargeback"
                            : "chargebacks"
                        }}
                      </span>
                    </d-list-group-item>
                  </d-list-group>
                </d-card-body>
                <d-card-footer class="border-top">
                  <d-row>
                    <!-- Footer -->
                    <d-col class="text-right view-report">
                      <a
                        class="go-stats__meta"
                        href="#"
                        v-on:click="OpenMerchants($event)"
                        >Ver todos</a
                      >
                      <button
                        class="btn button-arrow"
                        type="button"
                        v-on:click="OpenMerchants($event)"
                      >
                        <i class="fas fa-angle-down"></i>
                      </button>
                    </d-col>
                  </d-row>
                </d-card-footer>
              </d-card>
            </d-col>
          </d-row>
        </d-col>
      </div>
    </div>
    <a
      href="#"
      class="btn-float btn-primary"
      v-show="showBtnScroll"
      v-on:click="ScrollToTop($event)"
    >
      <i class="fa fa-chevron-up"></i>
    </a>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            placeholder="IdMerchantRoot"
            type="text"
            class="form-control"
            v-model="filter.IdMerchantRoot"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <date-field
            aria-label="Data Inicial"
            v-model="filter.InitialDate"
            format="dd MMMM yyyy"
            minimumView="day"
          ></date-field>
        </d-col>

        <d-col md="6" class="form-group">
          <date-field
            v-model="filter.EndDate"
            format="dd MMMM yyyy"
            minimumView="day"
            :minDate="this.filter.DateInitial"
          ></date-field>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import cards from "@/components/common/cards";
import dateField from "../common/date-field";

export default {
  name: "chargebacks-marketplace-dashboard",
  components: {
    cards,
    dateField,
  },
  watch: {
    "filter.InitialDate": function (nv, old) {
      this.filter.EndDate = this.filter.InitialDate;
    },
  },
  data: function () {
    return {
      loading: false,
      countFilter: 0,
      filter: {
        IdMerchantRoot: 0,
        InitialDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        EndDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      },
      infoDashboard: {
        AmountChargeback: 0,
        AmountChargebackPaid: 0,
        CountAuthorized: 0,
        CountPerformed: 0,
        CountChargeback: 0,
        ChargebackSubaccount: [],
      },
      showBtnScroll: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.HandleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.HandleScroll);
  },
  computed: {
    Cards() {
      return [
        {
          label: "Quantidade de transações realizadas",
          value: this.$options.filters.number(
            this.infoDashboard.CountPerformed
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
        {
          label: "Valor total transacionado",
          value: this.$options.filters.currency(
            this.infoDashboard.AmountChargeback
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
        {
          label: "Valor total repassado",
          value: this.$options.filters.currency(
            this.infoDashboard.AmountChargebackPaid
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
        {
          label: "Quantidade de autorizadas",
          value: this.$options.filters.number(
            this.infoDashboard.CountAuthorized
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
        {
          label: "Quantidade de chargback/em disputa",
          value: this.$options.filters.number(
            this.infoDashboard.CountChargeback
          ),
          smallFontSizeValue: true,
          lg: 4,
        },
      ];
    },
  },
  watch: {},
  mounted() {
    this.GetDashboard();
    this.$root.$on("bv::tooltip::show", (bvEvent) => {
      if (bvEvent.target.offsetWidth == bvEvent.target.scrollWidth)
        bvEvent.preventDefault();
    });
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.GetDashboard();
    },
    ResetFilter: function () {
      this.filter = {
        IdMerchantRoot: 0,
        InitialDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        EndDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      };
      this.GetDashboard();
    },
    GetDashboard: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.IdMerchantRoot)) this.countFilter++;
      if (hasValue(this.filter.InitialDate)) this.countFilter++;
      if (hasValue(this.filter.EndDate)) this.countFilter++;

      this.loading = true;
      let data = {
        ...{
          "Object.IdMerchantRoot": this.filter.IdMerchantRoot,
          "Object.InitialDate": this.filter.InitialDate,
          "Object.EndDate": this.filter.EndDate,
        },
      };

      if (this.filter.IdMerchantRoot > 0) {
        this.$store
          .dispatch("GetChargebackMarketplaceDashboard", { params: data })
          .then((response) => {
            this.infoDashboard = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao carregar o Dashboard",
              error
            );
          })
          .finally(() => (this.loading = false));
      } else {
        this.loading = false;
      }
    },
    HandleScroll: function () {
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400
      ) {
        this.showBtnScroll = true;
      } else {
        this.showBtnScroll = false;
      }
    },
    ScrollToTop: function () {
      window.scrollTo(0, 0);
    },
    OpenMerchants: function (e) {
      e.preventDefault();
      this.$router.push({
        name: "chargebackMarketplace",
        params: { idMerchantRoot: this.filter.IdMerchantRoot },
        query: {
          InitialDate: this.filter.InitialDate,
          EndDate: this.filter.EndDate,
        },
      });
    },
  },
};
</script>

<style scoped>
.padding-right-item {
  padding-right: 10px;
}
.padding-left-item {
  padding-left: 35px;
}
.icon-gold {
  color: #edd05c;
}
.icon-silver {
  color: #9ea5b5;
}
.icon-bronze {
  color: #e09848;
}
.button-arrow {
  padding: 0px;
}
.label-red {
  color: #ea234d;
}
</style>
<style>
.tooltip-inner {
  font-size: 10pt;
}
.iconList {
  font-size: 40px;
  margin-top: 15%;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/chargebacksMarketplaceDashboard.vue